import React from 'react';

import SearchField from '@adsk/alloy-react-search-field';
import theme from '@adsk/alloy-react-theme';

import { useTranslation } from '../../i18n';

function ScheduleSearchField({
  searchExpression,
  onSearchChange,
  disabled,
}: {
  searchExpression?: string;
  onSearchChange: (search: string) => void;
  disabled: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div>
      <SearchField
        style={{
          maxWidth: 225,
          minWidth: 200,
          'input:disabled': {
            background: theme.colors.white,
          },
        }}
        placeholder={t('SEARCH')}
        value={searchExpression ?? ''}
        onChange={onSearchChange}
        disabled={disabled}
      />
    </div>
  );
}

export default ScheduleSearchField;
